import React from "react";
import Container from "@mui/material/Container";
import ErrorComponent from "../component/ErrorComponent";

const About = () => {
  return (
    <Container sx={{ marginTop: "100px", marginBottom: "25px" }}>
      <ErrorComponent message="About Page is restricted from general access to protect user privacy and consent." />
    </Container>
  );
};

export default About;
